import React, { useState } from 'react'
import Icon from 'srcReact/components/icons/Icon'
import styles from './styles.module.scss'
import PillPure from './PillPure'
import ConfirmUpdateUserInterest from 'srcReact/components/popinsContent/ConfirmUpdateUserInterest'

const Pill = ({
  type = 'interest', //interest/expertise
  text,
  selected,
  selectedForRemoval,
  onClick,
  lastInterestRef,
  dataId,
  onKeyUp,
  onMouseEnter,
  onMouseLeave,
  className,
  size,
  showIcon,
  count,
  shared = false,
  askForAddToProfile = false,
  onAddPillSuccess
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [pillIdToAdd, setPillIdToAdd] = useState(null)
  const handleKeyUp = (e) => {
    if (onKeyUp) {
      onKeyUp(e)
    }
  }

  const handleMouseEnter = () => {
    if (onMouseEnter) {
      onMouseEnter()
    }
  }

  const handleMouseLeave = () => {
    if (onMouseLeave) {
      onMouseLeave()
    }
  }

  const closeModal = () => {
    setIsModalOpen(false)
    setPillIdToAdd(null)
  }

  const handlePillClick = (e) => {
    if (!shared) {
      setIsModalOpen(true)
      setPillIdToAdd(dataId)
    }
  }

  return (
    <React.Fragment>
      <PillPure
        type={type}
        text={text}
        dataId={dataId}
        lastInterestRef={lastInterestRef}
        selected={selected}
        selectedForRemoval={selectedForRemoval}
        onClick={onClick && !askForAddToProfile ? onClick : handlePillClick}
        className={`${className} ${onClick || askForAddToProfile ? styles.clickable : ''}`}
        handleKeyUp={handleKeyUp}
        handleMouseEnter={handleMouseEnter}
        handleMouseLeave={handleMouseLeave}
        renderUnselected={() => (
          <Icon
            name={
              type === 'interest' ? 'heart' : type === 'expertise' ? 'star-solid' : type === 'pinned' ? 'pin-badge' : ''
            }
            styleModifier={`${
              type == 'expertise' ? styles.expertiseIcon : type === 'pinned' ? styles.pinnedIcon : ''
            } ${styles.unSelected}`}
          />
        )}
        {...(selectedForRemoval
          ? {
              renderSelected: () => <Icon name={'delete'} styleModifier={styles.removeIcon} />
            }
          : {})}
        {...(selected && !selectedForRemoval
          ? {
              renderSelected: () => (
                <Icon
                  name={type === 'interest' ? 'heart' : 'star-solid'}
                  styleModifier={
                    type === 'interest'
                      ? styles.selectedInterest
                      : `${styles.expertiseIcon} ${styles.selectedExpertise}`
                  }
                />
              )
            }
          : {})}
        {...(shared && !selectedForRemoval
          ? {
              renderShared: () => (
                <Icon
                  name={type === 'interest' ? 'heart' : 'star-solid'}
                  styleModifier={`${type == 'expertise' ? styles.expertiseIcon : ''} ${styles.shared}`}
                />
              )
            }
          : {})}
        size={size}
        showIcon={showIcon}
        count={count}
        shared={shared}
      />
      {isModalOpen && pillIdToAdd && (
        <ConfirmUpdateUserInterest
          isModalOpen={isModalOpen}
          closeModal={closeModal}
          selectedInterest={{ name: text, id: pillIdToAdd, selected: false }}
          callbackSuccess={onAddPillSuccess}
        />
      )}
    </React.Fragment>
  )
}

export default Pill
